import React from 'react';
import ReactMarkdown from 'react-markdown';
import { PERSONAS } from '../personas';

// 캐릭터(페르소나) 객체: 필요시 별도 파일로 분리해도 좋습니다.
// /home/ladmin/docker/sorabot/frontend/sorabot-project/src/personas.js

/**
 * ChatMessage 컴포넌트
 * @param {Object} props
 *   - messageContent: 메시지 문자열
 *   - sender: 'user' | 'bot'
 *   - persona: string ('sorabot' | 'chasera' | ...)
 */
function ChatMessage({ messageContent, sender, persona = "sorabot" }) {

  // persona에 해당하는 캐릭터 객체
  const personaInfo = PERSONAS[persona] || PERSONAS["sorabot"];

  // 봇 메시지라면 아바타 표시용 URL
//  const avatarUrl = sender === "bot" ? personaInfo.avatar : null;
  const avatarUrl = sender === "bot" ? personaInfo.chatIcon : null;

  const messageClasses = `
    p-3 rounded-xl max-w-[75%] shadow-md
    ${sender === 'user'
      ? 'bg-blue-500 text-white rounded-br-none'
      : 'bg-gray-200 text-gray-800 rounded-bl-none'
    }
  `;
  const containerClasses = `
    flex mb-4
    ${sender === 'user' ? 'justify-end' : 'justify-start'}
  `;

  return (
    <div className={containerClasses}>
      {/* 봇 메시지에만 캐릭터 아이콘(아바타) 표시 */}
      {sender === 'bot' && (
        <img
          src={avatarUrl}
          alt={`${personaInfo.name} 아바타`}
          style={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            marginRight: 10,
            border: '1px solid #e0e0e0',
            objectFit: 'cover',
          }}
        />
      )}
      <div className={messageClasses}>
        <ReactMarkdown>
          {messageContent}
        </ReactMarkdown>
      </div>
    </div>
  );
}

export default ChatMessage;

